import * as S from "./EquipStatusItem.style";

export interface EquipStatusItemBase {
  title?: string;
  power?: boolean;
  status?: "normal" | "warning" | "critical" | "off";
  $pLeft?: any;
  $pTop?: any;
  $pRight?: any;
  $pBottom?: any;
  path?: string;
}

interface EquipStatusItemProps extends EquipStatusItemBase {
  navigateToPath: (path?: string) => void;
  onContextMenu: (event: React.MouseEvent, target: any) => void;
}

export const EquipStatusItem = ({
  title,
  power,
  status,
  $pLeft,
  $pTop,
  $pRight,
  $pBottom,
  path,
  navigateToPath,
  onContextMenu,
}: EquipStatusItemProps) => {
  return (
    <S.EquipStatusItem
      $pLeft={$pLeft && $pLeft}
      $pRight={$pRight && $pRight}
      $pTop={$pTop && $pTop}
      $pBottom={$pBottom && $pBottom}
      $path={path}
      onClick={() => status !== "off" && navigateToPath(path)}
      onContextMenu={(e) =>
        status !== "off" && onContextMenu(e, "/equipment/gas-turbine/0")
      }
    >
      {status && (
        <S.EquipStatusPower $power={power}>
          {power ? "on" : "off"}
        </S.EquipStatusPower>
      )}
      <S.EquipStatusBox $status={status}>{title}</S.EquipStatusBox>
    </S.EquipStatusItem>
  );
};
